
angular.module('amcGrantReport', ['dyb.util'])
